import { UserOutlined } from "@ant-design/icons";
import { useGetAllUsersQuery } from "../Redux/service/Users/Users";

export const useUsers = () => {
	const { data: usersData, isFetching } = useGetAllUsersQuery({
		page: 1,
		pageSize: 10000,
	});

	const users =
		usersData?.data?.map((user) => ({
			id: `${user.id}`,
			name: user.name,
			avatar: user.profile_photo
				? `${process.env.REACT_APP_BACKEND_URL}Test/${user.profile_photo}`
				: null,
			email: user.email,
		})) || [];

	const options = users.map((user) => ({
		value: user.id,
		label: (
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				{user.avatar ? (
					<img
						src={user.avatar}
						alt={user.name}
						style={{ width: 24, height: 24, borderRadius: "50%" }}
					/>
				) : (
					<UserOutlined
						style={{ width: 24, height: 24, borderRadius: "50%" }}
					/>
				)}
				<span>{user.name}</span>
			</div>
		),
		searchLabel: user.name.toLowerCase(),
	}));

	const makeOption = (user) => ({
		value: user.id,
		label: user.name, // keep this as a string for searching
		renderLabel: (
			<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
				{user.avatar ? (
					<img
						src={user.avatar}
						alt={user.name}
						style={{ width: 24, height: 24, borderRadius: "50%" }}
					/>
				) : (
					<UserOutlined
						style={{ width: 24, height: 24, borderRadius: "50%" }}
					/>
				)}
				<span>{user.name}</span>
			</div>
		),
		searchLabel: user.name.toLowerCase(), // optional, if your InputSelect uses it
	});

	const customers =
		usersData?.data?.filter((u) => u.attributes.isCustomer) || [];
	const managers =
		usersData?.data?.filter(
			(u) => !u.attributes.isCustomer && !u.attributes.field_worker,
		) || [];

	const customerOptions = customers.map(makeOption);
	const managerOptions = managers.map(makeOption);

	return {
		usersData,
		users,
		options,
		isFetching,
		customers,
		managers,
		customerOptions,
		managerOptions,
	};
};
